import React from 'react';
import Discount from 'App/models/discount';
import CartDeliveryInfo from './CartDeliveryInfo';
import CartTotalRow from './CartTotalRow';
var CartSummary = function (props) {
    var isEmpty = props.isEmpty, restaurant = props.restaurant, isTakeoutMode = props.isTakeoutMode;
    var basketStatus = props.basketStatus;
    var _a = basketStatus.price, cartTotalDiscount = _a.discounts_value, cartDiscounted = _a.discounted, cartTotal = _a.total, _b = basketStatus.upselling, upselling = _b === void 0 ? [] : _b, _c = basketStatus.discounts, discounts = _c === void 0 ? [] : _c;
    return (React.createElement(React.Fragment, null,
        React.createElement(CartTotalRow, { label: "Warto\u015B\u0107 koszyka", value: cartTotal }),
        !!discounts.length && (React.createElement(React.Fragment, null,
            React.createElement(CartTotalRow, { label: discounts.length > 1 ? 'Łączny rabat' : 'Rabat', value: cartTotalDiscount }),
            discounts.length > 1 &&
                discounts.map(function (discountItem) { return (React.createElement(CartTotalRow, { key: discountItem.type, className: "small text-success", label: Discount.getDiscountItemLabel(discountItem), value: discountItem.value })); }),
            React.createElement(CartTotalRow, { label: isTakeoutMode ? 'Razem' : 'Po rabacie', last: isTakeoutMode, value: cartDiscounted }))),
        !isTakeoutMode && !isEmpty && (React.createElement(CartDeliveryInfo, { basketStatus: basketStatus, restaurant: restaurant }))));
};
CartSummary.displayName = 'CartSummary';
export default CartSummary;
